import React, { useCallback, useEffect, useMemo } from 'react';
import { Cascader } from 'antd';
import { Box } from '@material-ui/core';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { useSelector, useDispatch } from 'dva';
import { CascaderMlStyled } from './CascaderMlStyled';

const CascaderML = (props) => {
  const dispatch = useDispatch();
  const {
    disabled,
    value,
    cascadeData,
    initStatus,
    fieldNames,
    isShowSearch = false,
    placeholder,
    isDisplayRender = false,
  } = props;
  const fetchRegionList = useCallback(() => {
    dispatch({
      type: 'common/getRegionList',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  useEffect(() => {
    !initStatus && fetchRegionList();
  }, [fetchRegionList, initStatus]);
  const regionFetchList = useSelector((state) => state.common.regionList);
  const regionList = initStatus ? cascadeData : regionFetchList;
  const newRegionList = useMemo(() => {
    Array.isArray(regionList) &&
      regionList.forEach((item) => {
        if (item.children && item.children.length === 0) {
          item.disabled = true;
        }
      });
    return regionList;
  }, [regionList]);

  function onChange(e, selectedItem) {
    props.handleChangePca(e, selectedItem);
  }
  const newValue = useMemo(() => {
    if (value && Array.isArray(value) && value.length > 0) {
      const arr = value.map((item) =>
        typeof item === 'object' ? item.id : item,
      );
      return arr;
    }
  }, [value]);

  const filter = (inputValue, path) => {
    return path.some(
      (option) =>
        option[fieldNames.label]
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) > -1,
    );
  };
  const displayRender = (labels) => {
    const showLabel = labels?.join('/') || '';
    return isDisplayRender ? (
      <span className="display-render-wrap">
        {labels[labels.length - 1]}
        {showLabel && (
          <span className="display-render-tip">
            {showLabel} <span className="display-render-tip-arrow"></span>
          </span>
        )}
      </span>
    ) : (
      showLabel
    );
  };

  return (
    <CascaderMlStyled isDisplayRender={isDisplayRender}>
      <Box className="antd-cascade--wrap" height="40px">
        <Cascader
          getPopupContainer={() =>
            document.getElementsByClassName('antd-cascade--wrap')[0]
          }
          disabled={disabled}
          bordered={false}
          suffixIcon={
            <SvgIconML
              name="arrow-drop-down"
              size={10}
              fill="#1565c0"
              className="preview"
            />
          }
          value={newValue}
          options={newRegionList}
          onChange={onChange}
          className={disabled ? 'disabled cascader-wrap' : 'edit cascader-wrap'}
          placeholder={placeholder || props.label}
          fieldNames={fieldNames}
          showSearch={isShowSearch ? { filter } : false}
          displayRender={displayRender}
        />
      </Box>
    </CascaderMlStyled>
  );
};
export default CascaderML;
